import classNames from "classnames";
import Link from "next/link";
import { UserGuideTooltip } from "../UserGuideTooltip";
import styles from "./index.module.less";

export default function HBTab({
  tabs,
  className,
  divider = true,
  currentTab,
  onChange,
  align = "center",
  style = null,
}: {
  currentTab: string;
  tabs: {
    key: string;
    title: string;
    href?: string;
    onClick?: (tab: { key: string; title: string }) => void;
    id?: string;
    userGuideTooltip?: any;
  }[];
  className?: string;
  divider: boolean;
  onChange?: (tab: string) => void;
  align?: "center" | "left" | "right";
  style?: Record<string, number | string>;
}) {
  return (
    <div className={classNames(styles.tabContainer, className)} style={style}>
      <div className={styles.tabButtons} style={{ justifyContent: align }}>
        {tabs.map(({ key, title, href, onClick, id, userGuideTooltip }) => {
          let item;
          if (href) {
            item = (
              <Link
                key={key}
                href={href}
                id={id}
                data-gd-click="button_click"
                data-button-name={title}
                className={classNames(styles.tabButton, {
                  [styles.current]: currentTab === key,
                })}
              >
                {title}
              </Link>
            );
          } else {
            item = (
              <a
                key={key}
                data-gd-click="button_click"
                data-button-name={title}
                className={classNames(styles.tabButton, {
                  [styles.current]: currentTab === key,
                })}
                onClick={() => {
                  onClick?.({ key, title });
                }}
              >
                {title}
              </a>
            );
          }
          return userGuideTooltip ? (
            <UserGuideTooltip {...userGuideTooltip}>{item}</UserGuideTooltip>
          ) : (
            item
          );
        })}
      </div>
      {/* 分割线 */}
      {divider && <div className={styles.divider} />}
    </div>
  );
}
